import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import Keycloak from 'keycloak-js';
import { Observable } from 'rxjs';
import { ArrayUtils } from 'src/app/shared/utils/array.utils';

@Injectable({
  providedIn: 'root',
})
export class KibGuard {
  private readonly keycloak = inject(Keycloak);
  private readonly router = inject(Router);

  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const allowedRoles = ['kib_admin', 'kib_user'];

    const isAllowed = this.userRoles.some((role) => allowedRoles.includes(role));
    if (!isAllowed) {
      this.router.navigate(['/']);
    }
    return isAllowed;
  }

  public get userRoles(): string[] {
    const userRoles: string[] = [];
    const tokenParsed = this.keycloak.tokenParsed;
    const roles = ArrayUtils.ensureArray(tokenParsed?.realm_access?.roles);
    roles.forEach((role) => {
      userRoles.push(role);
    });
    return userRoles;
  }
}
